import { c as _c } from "react/compiler-runtime";
import { getErrorMessage } from '@onefootprint/request';
import { SkipLivenessClientType, SkipLivenessReason } from '@onefootprint/types/src/api/skip-liveness';
import { LoadingSpinner } from '@onefootprint/ui';
import { useEffect } from 'react';
import { getLogger, trackAction } from '@/idv/utils';
import { NavigationHeader } from '../../../../components';
import { useSkipLiveness } from '../../../../queries';
import { checkIsSocialMediaBrowser } from '../../../../utils';
import useLivenessMachine from '../../hooks/use-liveness-machine';
const {
  logWarn,
  logInfo
} = getLogger({
  location: 'passkeys-unavailable'
});
const Unavailable = () => {
  const $ = _c(10);
  const [state, send] = useLivenessMachine();
  const {
    idvContext: t0
  } = state.context;
  const {
    authToken,
    device,
    isInIframe
  } = t0;
  const skipLivenessMutation = useSkipLiveness();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] !== authToken || $[2] !== device?.hasSupportForWebauthn || $[3] !== isInIframe || $[4] !== send || $[5] !== skipLivenessMutation) {
    t2 = () => {
      if (!authToken) {
        logWarn("Cannot continue as authToken is not defined");
        return;
      }
      let reason = SkipLivenessReason.unknown;
      if (!device?.hasSupportForWebauthn) {
        reason = SkipLivenessReason.unavailableOnDevice;
      } else {
        if (isInIframe) {
          if (checkIsSocialMediaBrowser()) {
            reason = SkipLivenessReason.unavailableInSocialIframe;
          } else {
            reason = SkipLivenessReason.unavailableInIframe;
          }
        }
      }
      logInfo(`Skipping passkeys: ${reason}`);
      trackAction("passkeys:unavailable", {
        reason
      });
      const context = {
        reason,
        clientType: SkipLivenessClientType.web,
        numAttempts: 0,
        attempts: []
      };
      skipLivenessMutation.mutate({
        authToken,
        context
      }, {
        onSuccess: () => {
          logInfo("Skipped passkeys with success");
          send({
            type: "completed"
          });
        },
        onError: _temp2
      });
    };
    $[1] = authToken;
    $[2] = device?.hasSupportForWebauthn;
    $[3] = isInIframe;
    $[4] = send;
    $[5] = skipLivenessMutation;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== authToken) {
    t3 = [authToken];
    $[7] = authToken;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center h-full justify-center min-h-[var(--loading-container-min-height)]"><NavigationHeader /><LoadingSpinner size="xlarge" /></div>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default Unavailable;
function _temp() {
  logInfo("Passkeys unavailable started");
}
function _temp2(error) {
  logWarn(`Error while skipping passkeys: ${getErrorMessage(error)}`, error);
}